// extracted by mini-css-extract-plugin
export var bodySections = "_3z-8";
export var gray = "_3z-7";
export var green = "_3z-4";
export var iconContainer = "_3z-9";
export var iconWidgetContainer = "_3z-1";
export var phoneIcon = "_3z-2";
export var red = "_3z-5";
export var statusDot = "_3z-3";
export var widgetContainer = "_3z-0";
export var yellow = "_3z-6";